import { render, staticRenderFns } from "./TorneoContextBar.vue?vue&type=template&id=2d37c4a9&scoped=true"
import script from "./TorneoContextBar.vue?vue&type=script&lang=js"
export * from "./TorneoContextBar.vue?vue&type=script&lang=js"
import style0 from "./TorneoContextBar.vue?vue&type=style&index=0&id=2d37c4a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d37c4a9",
  null
  
)

export default component.exports